module.exports = __webpack_public_path__ + "static/media/machine1.860ba23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/machine1.png
// module id = 862
// module chunks = 0